import useFetchAllProperties from 'components/domain/property/useFetchAllProperties';
import { PROPERTY_STATUS } from 'models/Properties';
import { API_MAX_LIMIT } from 'services/API.constants';
import getPropertiesQuery from 'utils/property/getPropertiesQuery';

const useFetchAssistProperties = () => {
  const { allProperties, isFetching } = useFetchAllProperties({
    enabled: true,
    conditions: getPropertiesQuery({
      filters: {
        limit: API_MAX_LIMIT,
        status: PROPERTY_STATUS.ACTIVE,
        topLevelOnly: true,
      },
    }),
    fields:
      'uid,name,isActive,businessType,numberOfSubUnits,unitTypes{uid,units{uid}}',
    operationName: 'HostfullyAssistProperties',
  });

  return { allProperties, isFetching };
};

export default useFetchAssistProperties;
